exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".especiales-sf-content {\n  padding-bottom: 150px;\n}\n\n.especiales-sf-content .options-section{\n  padding-left: 30px;\n  padding-right: 30px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /app/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/app/node_modules/postcss-loader?{"ident":"postcss"}!/app/src/styles/especiales-sf.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles/especiales-sf.css
// module chunks = styles